//export const environment = {
//    production: true,
//    appcode: 'INTASCRB',
//    serviceBaseUrl: 'https://inqa1.ey.com/resumebuilder/ResumeBuilderService/api/',
//    tokenPath: 'https://inqa1.ey.com/resumebuilder/ResumeBuilderService/api/Token',
//    logApplicationInsights: 'N',
//    isHostingEnvAzure: true,
//    msalConfig: {
//        authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
//        tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
//        clientId: 'b5e20aed-3b4e-4445-952e-33628229c39f',
//        redirectUri: 'https://inqa1.ey.com/resumebuilder'
//    }
//};
export const environment = {
    production: true,
    appcode: 'INTASCRB',
    serviceBaseUrl: 'https://inresumebuilder-uat.ey.net/ResumeBuilderAPI/api/',
    tokenPath: 'https://inresumebuilder-uat.ey.net/ResumeBuilderAPI/api/Token',
    logApplicationInsights: 'Y',
    isHostingEnvAzure: true,
    instrumentationKey: '306905d2-b24a-4274-bf34-a65c81c66ca3',
    msalConfig: {
        authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
        tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
        clientId: 'b5e20aed-3b4e-4445-952e-33628229c39f',
        redirectUri: 'https://inresumebuilder-uat.ey.net'
    }
};
import 'zone.js/dist/zone-error';

